// removed by extract-text-webpack-plugin
module.exports = {"SideDraw":"SideDraw__SideDraw__j4Fu4","Links":"SideDraw__Links__2x7aB","CloseButton":"SideDraw__CloseButton__2yYdE","Open":"SideDraw__Open__3Lmso","Close":"SideDraw__Close__ig1fu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/SideDraw/SideDraw.css
// module id = 55
// module chunks = 0